import { Box } from '@mui/material';
import { CustomTextField, LabelContent } from '../../../common';

const DebtEditTotals = ({ coupons, modifiedCoupons, payChecks, regularizeChecks }) => {
  const calculateTotals = () => {
    let totalPay = 0;
    let totalRegularize = 0;

    coupons?.forEach((coupon, index) => {
      if (payChecks[index]) {
        const thirdDueAmount =
          modifiedCoupons[index]?.third_due_amount || coupon.third_due_amount || 0;
        totalPay += thirdDueAmount;
      }

      if (regularizeChecks[index]) {
        const originalAmount = coupon.first_due_amount || 0;
        const thirdDueAmount =
          modifiedCoupons[index]?.third_due_amount || coupon.third_due_amount || 0;
        const interest = thirdDueAmount - originalAmount;
        totalRegularize += interest > 0 ? interest : 0;
      }
    });

    return { totalPay, totalRegularize };
  };

  const totals = calculateTotals();

  return (
    <Box
      sx={{
        backgroundColor: '#f8f9fa',
        padding: '10px 10px',
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        gap: 6,
        minHeight: '20px',
        flexShrink: 0,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          alignContent: 'center',
          gap: 2,
          padding: '8px 16px',
          borderRadius: '8px',
        }}
      >
        <LabelContent
          label="Total Pagar"
          labelColor="#5e894f"
          sx={{
            fontSize: '18px',
            fontWeight: 'bold',
            margin: 0,
          }}
        />
        <CustomTextField
          size="small"
          value={`${totals.totalPay.toFixed(2)}`}
          disabled
          sx={{
            mt: 0,
            width: '160px',
            '& input': {
              textAlign: 'center',
              fontWeight: 'bold',
              fontSize: '16px',
              backgroundColor: 'white',
              color: '#5e894f',
            },
            '& .MuiOutlinedInput-root': {
              '& fieldset': {
                borderColor: '#5e894f',
                borderWidth: '2px',
              },
            },
          }}
        />
      </Box>

      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          alignContent: 'center',
          gap: 2,
          borderRadius: '8px',
        }}
      >
        <LabelContent
          label="Total Regularizar"
          labelColor="#b8860b"
          sx={{
            fontSize: '18px',
            fontWeight: 'bold',
            margin: 0,
          }}
        />
        <CustomTextField
          size="small"
          value={`${totals.totalRegularize.toFixed(2)}`}
          disabled
          sx={{
            mt: 0,
            width: '160px',
            '& input': {
              textAlign: 'center',
              fontWeight: 'bold',
              fontSize: '16px',
              backgroundColor: 'white',
              color: '#b8860b',
            },
            '& .MuiOutlinedInput-root': {
              '& fieldset': {
                borderColor: '#b8860b',
                borderWidth: '2px',
              },
            },
          }}
        />
      </Box>
    </Box>
  );
};

export default DebtEditTotals;
